import FormController from 'controllers/form-controller';

export default class LoginFormController extends FormController {
  connect() {
    super.connect();
  }

  validateFields(event) {
    super.validateFields(event);

    if (this.formValid) {
      this.submit();
    }
  }
}
